import { render } from "./PrvSizing.vue?vue&type=template&id=5e5d16d2&scoped=true"
import script from "./PrvSizing.vue?vue&type=script&lang=js"
export * from "./PrvSizing.vue?vue&type=script&lang=js"

import "./PrvSizing.vue?vue&type=style&index=0&id=5e5d16d2&scoped=true&lang=css"
import "./PrvSizing.vue?vue&type=style&index=1&id=5e5d16d2&lang=css"

import exportComponent from "C:\\Users\\peter\\Documents\\_projekte\\georg_fischer\\vue3_prv_sizing_tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5d16d2"]])

export default __exports__